import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { _className, Button, ComponentSync, LL_H_C } from '@nu-art/thunderstorm-frontend/index';
import { ICONS } from '@app/styles';
import { BadImplementationException, formatTimestamp } from '@nu-art/ts-common';
import { inboxItemsStatus_CompletedAndViewed, inboxItemStatus_ActionNeeded, inboxItemStatus_Completed, inboxItemStatus_Pending } from './types.js';
import './Component_InboxItem.scss';
import { ModuleFE_EMInterface } from '@app/advisor-frontend';
import { Loader_OrderButton } from '../../panels/AdvisorPanel_NextSteps/Renderer_Order/Loader_OrderButton.js';
export class Component_InboxItem_Base extends ComponentSync {
    //######################### Life Cycle #########################
    __onPathwayEndUpdated() {
        // Re-derive state if we reached disposition
        if (ModuleFE_EMInterface.isPostDisposition())
            this.reDeriveState();
    }
    deriveStateFromProps(nextProps, state) {
        state.disabled = nextProps.disabled || ModuleFE_EMInterface.isPostDisposition() || ModuleFE_EMInterface.isAvatarMode();
        state.status = this.getStatus(state);
        state.selected ??= false;
        state.itemData ??= {
            label: this.getLabel(state),
            timestamp: this.getTimestamp(state),
            iconKey: this.getIconKey(state),
        };
        return state;
    }
    //######################### Logic #########################
    getStatusIconData = () => {
        switch (this.state.status) {
            case inboxItemStatus_Pending:
                return {
                    key: 'advisor_avn_hourglass',
                    class: 'pending',
                };
            case inboxItemStatus_ActionNeeded:
                return {
                    key: 'advisor_v5_inbox_arrowWithBG',
                    class: 'active',
                };
            case inboxItemStatus_Completed:
            case inboxItemsStatus_CompletedAndViewed:
                return {
                    key: 'advisor_v5_inbox_checkWithBG',
                    class: this.state.status === inboxItemStatus_Completed ? 'active' : undefined
                };
            default:
                throw new BadImplementationException(`Missing icon implementation for status ${this.state.status}`);
        }
    };
    onClick = async (e) => {
        if (this.state.disabled)
            return;
        await this.onItemClick(e);
    };
    getClassName() {
        return _className(this.state.selected && 'selected');
    }
    //######################### Render #########################
    render() {
        const className = this.getClassName();
        return _jsxs(Button, { variant: 'inbox-item', className: className, onClick: this.onClick, loader: Loader_OrderButton, children: [this.render_TypeIcon(), this.render_Label(), this.render_Timestamp(), this.render_StatusIcon()] });
    }
    render_TypeIcon = () => {
        const key = this.state.itemData.iconKey;
        const Icon = ICONS[key];
        return _jsx(LL_H_C, { className: 'inbox-item__type-icon', children: _jsx(Icon.component, {}) });
    };
    render_Label = () => {
        return _jsx("div", { className: 'inbox-item__label', children: this.state.itemData.label });
    };
    render_Timestamp = () => {
        const timestamp = formatTimestamp('hh:mma', this.state.itemData.timestamp);
        return _jsx("div", { className: 'inbox-item__timestamp', children: timestamp });
    };
    render_StatusIcon = () => {
        const statusIconData = this.getStatusIconData();
        const Icon = ICONS[statusIconData.key];
        return _jsx(Icon.component, { className: _className('inbox-item__status-icon', statusIconData.class) });
    };
}
//# sourceMappingURL=Component_InboxItem_Base.js.map